import { apiGateway } from "@contexts";
import { GetBankTransactionChallengeResponse } from "@interfaces";
import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import {
  ErrorType,
  onQuestionChallengeAxiosErrorInterpreter,
} from "@screens/FeaAuth/hooks/onQuestionChallengeError";
import { useBankTransferAttempts } from "./useBankTransferAttempts";

interface Props {
  onError: (error: Error) => void;
}

export const useCreateBankTransferChallenge = ({ onError }: Props) => {
  const { registerAttempt } = useBankTransferAttempts();

  const onSuccess = useCallback(
    ({
      simplifiedPaymentUrl,
      paymentUrl,
    }: GetBankTransactionChallengeResponse) => {
      registerAttempt();
      window.location.href = simplifiedPaymentUrl || paymentUrl;
    },
    [registerAttempt],
  );

  return useMutation({
    mutationFn: async () => {
      const challenge = await apiGateway<
        GetBankTransactionChallengeResponse,
        ErrorType
      >(
        {
          url: "/enrolment/bank-transfer-challenge",
          method: "POST",
        },
        onQuestionChallengeAxiosErrorInterpreter,
      );
      if (!challenge.simplifiedPaymentUrl && !challenge.paymentUrl) {
        throw new Error("missingPaymentUrl");
      }
      return challenge;
    },
    onSuccess,
    onError,
  });
};
